import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { validateCreatorFile } from '../utils/mediaValidation';

const MentionPopup = ({ subjects, onSelect, onCreate, onDelete, onClose, filter }) => {
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState('');
  const [newImageUrl, setNewImageUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(null); // subject id with open menu
  const fileInputRef = useRef(null);
  const popupRef = useRef(null);
  const nameInputRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  useEffect(() => {
    if (creating && nameInputRef.current) {
      nameInputRef.current.focus();
    }
  }, [creating]);

  const filtered = filter
    ? subjects.filter((s) => s.name.toLowerCase().includes(filter.toLowerCase()))
    : subjects;

  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = '';

    try {
      await validateCreatorFile(file, { scope: 'image-only' });
    } catch (error) {
      alert(error.message);
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await axios.post('/api/creator/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (res.data.success) {
        setNewImageUrl(res.data.data.url);
      } else {
        alert('上传失败: ' + (res.data.message || '未知错误'));
      }
    } catch (err) {
      alert('上传失败: ' + (err.response?.data?.message || err.message));
    } finally {
      setUploading(false);
    }
  };

  const handleCreate = () => {
    if (!newName.trim()) return;
    const subject = {
      id: 'subj-' + Date.now(),
      name: newName.trim(),
      imageUrl: newImageUrl || '',
    };
    onCreate(subject);
    setCreating(false);
    setNewName('');
    setNewImageUrl('');
  };

  return (
    <div className="mention-popup" ref={popupRef}>
      <div className="mention-popup-header">可能@的内容</div>

      {!creating && (
        <div
          className="mention-popup-item create"
          onClick={() => setCreating(true)}
        >
          <div className="mention-popup-thumb create-icon">
            <span>+</span>
          </div>
          <span className="mention-popup-name">创建主体</span>
        </div>
      )}

      {creating && (
        <div className="mention-popup-create-form">
          <div className="mention-popup-create-row">
            <div
              className="mention-popup-create-thumb"
              onClick={() => fileInputRef.current?.click()}
            >
              {uploading ? (
                <div className="mention-popup-create-loading" />
              ) : newImageUrl ? (
                <img src={newImageUrl} alt="" />
              ) : (
                <span>+</span>
              )}
            </div>
            <input
              ref={nameInputRef}
              className="mention-popup-create-input"
              placeholder="输入主体名称"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleCreate();
                if (e.key === 'Escape') { setCreating(false); setNewName(''); setNewImageUrl(''); }
              }}
            />
            <button
              className="mention-popup-create-btn"
              onClick={handleCreate}
              disabled={!newName.trim()}
            >
              确定
            </button>
          </div>
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
        </div>
      )}

      <div className="mention-popup-list">
        {filtered.map((subj) => (
          <div
            key={subj.id}
            className="mention-popup-item"
            onClick={() => onSelect(subj)}
          >
            <div className="mention-popup-thumb">
              {subj.imageUrl ? (
                <img src={subj.imageUrl} alt={subj.name} />
              ) : (
                <span className="mention-popup-thumb-placeholder">
                  {subj.name.charAt(0)}
                </span>
              )}
            </div>
            <span className="mention-popup-name">{subj.name}</span>
            {onDelete && (
              <button
                className="mention-popup-more"
                onClick={(e) => {
                  e.stopPropagation();
                  setMenuOpen(menuOpen === subj.id ? null : subj.id);
                }}
              >
                ···
              </button>
            )}
            {menuOpen === subj.id && (
              <div className="mention-popup-item-menu">
                <div
                  className="mention-popup-item-menu-option"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(subj.id);
                    setMenuOpen(null);
                  }}
                >
                  删除
                </div>
              </div>
            )}
          </div>
        ))}
        {filtered.length === 0 && !creating && (
          <div className="mention-popup-empty">暂无主体，点击上方创建</div>
        )}
      </div>
    </div>
  );
};

export default MentionPopup;
